import React, { useState, useEffect } from 'react';
import { NavLink, withRouter } from 'react-router-dom';
import moment from 'moment';

import { config } from '../../../../config/index';
import { GET, POST, newFetch } from '../../../../helpers/fetch';

import { to12Hr } from '../../../../helpers/moment';

import AppContext from '../../../../store/App/contexts';
import LayoutContext from '../../../../store/Layout/contexts';
import Searchbar from '../../../../components/Searchbar';
import Upload from '../../../../components/Input/Upload';
import ToastUtil from '../../../../components/ToastNotification/ToastUtil';
import AlertService from '../../../../components/SweetAlert';
import placeholderImage from '../../../../assets/images/placeholder.jpg';
const { SERVER_URL } = config;

const AddTT = ({ history }) => {
  //const client = JSON.parse(localStorage.getItem('user'));
  const type = localStorage.getItem('type');
  const {
    fetchClientsOptions,
    client_options,
    selectedClientID,
    site_options,
    fetchSiteOptions,
    selectedSiteID,
  } = React.useContext(AppContext);
  const [client, setClient] = useState('');
  const clientID = parseInt(localStorage.getItem('client'), 10);
  const siteID = parseInt(localStorage.getItem('site'), 10);
  const [site, setSite] = useState('');

  const [sites, setSites] = useState([]);
  const [selectedSite, setSelectedSite] = useState(null);
  const [associates, setAssociates] = useState([]);
  const [filteredAssociates, setFilteredAssociates] = useState([]);
  const [selectedAssociates, setSelectedAssociates] = useState([]);

  const [incidents, setIncidents] = useState([]);
  const [ttGroups, setTTGroups] = useState([]);

  const [selectedIncident, setSelectedIncident] = useState(null);
  const [SEV, setSEV] = useState(null);
  const [selectedTTGroups, setSelectedTTGroups] = useState([]);

  const [title, setTitle] = useState('');
  const [description, setDescription] = useState('');
  const [files, setFiles] = useState([]);

  const [showFilter, setShowFilter] = useState(false);
  const [filterDate, setFilterDate] = useState(null);
  const [schedules, setSchedules] = useState([]);
  const [filterSchedule, setFilterSchedule] = useState(null);

   useEffect(() => {
      setClient(selectedClientID);
    }, [selectedClientID]);
  
    useEffect(() => {
      setSite(selectedSiteID);
    }, [selectedSiteID]);

  // Fetch Site
  useEffect(() => {
    const fetchSites = async () => {
      let api_path = `/client/${clientID}/site`;
      let response = await newFetch(GET, api_path);

      if (response.success) {
        setSites(response.data);
      }
    };


    fetchClientsOptions(type);
    fetchSiteOptions();
  }, []);

  // Fetch Associates
  useEffect(() => {
    const fetchAssociates = async () => {
      let api_path = `/site/${site}/associates`;
      let response = await newFetch(GET, api_path);

      if (response.success) {
        setAssociates(response.data);
        setFilteredAssociates(JSON.parse(JSON.stringify(response.data)));
      }
    };

    const fetchTTGroups = async () => {
      let api_path = `/site/${site}/ttgroup`;
      let response = await newFetch(GET, api_path);

      if (response.success) {
        setTTGroups(response.data);
      }
    };

    if (site) {
      fetchAssociates();
      fetchTTGroups();
    }
  }, [site]);

  useEffect(() => {
    const fetchIncidents = async () => {
      let api_path = `/tt/incident`;
      let response = await newFetch(GET, api_path);

      if (response.success && response.data.length > 0) {
        setIncidents(response.data);
      }
    };

    fetchIncidents();
  }, []);

  useEffect(() => {
    if (selectedIncident) {
      setSEV(selectedIncident.severity);
    } else {
      setSEV(null);
    }
  }, [selectedIncident]);

  useEffect(() => {
    if (selectedIncident && ttGroups.length > 0) {
      setSelectedTTGroups(
        JSON.parse(JSON.stringify([...ttGroups])).filter((group) =>
          group.group_incidents.some(
            (incident) => incident.incident.id === selectedIncident.id
          )
        )
      );
    } else {
      setSelectedTTGroups([]);
    }
  }, [selectedIncident, ttGroups]);

  useEffect(() => {
    const fetchSchedule = async () => {
      let data = {
        start_date: filterDate,
        end_date: filterDate,
      };

      let api_path = `/site/${site}/schedule`;
      let response = await newFetch(POST, api_path, data);

      if (response.data && response.data.length > 0) {
        setSchedules(response.data);
      } else {
        setSchedules([]);
        setFilterSchedule(null);
      }
    };

    if (site && filterDate) {
      fetchSchedule();
    } else {
      setSchedules([]);
      setFilterSchedule(null);
    }
  }, [site, filterDate]);

  const searchHandler = (e) => {
    let filtered = [...associates].filter((associate) => {
      let name = `${associate.first_name} ${associate.last_name}`;
      return name.toUpperCase().indexOf(e.target.value.toUpperCase()) > -1;
    });

    setFilteredAssociates(filtered);
  };

  const clearFilterHandler = () => {
    setFilteredAssociates(associates);
    setSchedules([]);
    setFilterDate('');
    setFilterSchedule(null);
  };

  const applyFilterHandler = async () => {
    if (!site) {
      ToastUtil.error('Please select site.');
    }

    if (!filterDate) {
      ToastUtil.error('Please select dates to load shifts.');
      return false;
    }

    if (!filterSchedule) {
      ToastUtil.error('Please select shifts to apply filter.');
      return false;
    }

    let api_path = `/schedule/${filterSchedule.id}/associates`;
    let response = await newFetch(GET, api_path);

    if (response.success) {
      let associatesArr = [
        ...response.data.assigned,
        ...[...response.data.late].filter(
          (associate) => associate.status === 3
        ),
      ];
    } else {
      setFilteredAssociates(associates);
      setSelectedAssociates([]);
    }
  };

  const selectRemoveAssociateHandler = (associate_id) => {
    if (selectedAssociates.some((id) => id === associate_id)) {
      setSelectedAssociates(
        [...selectedAssociates].filter((id) => id !== associate_id)
      );
    } else {
      setSelectedAssociates([...selectedAssociates, associate_id]);
    }
  };

  const selectAllHandler = (e) => {
    e.preventDefault();
    setSelectedAssociates(
      JSON.parse(JSON.stringify([...filteredAssociates])).map(
        (associate) => associate.id
      )
    );
  };

  const removeAllHandler = (e) => {
    e.preventDefault();
    setSelectedAssociates([]);
  };

  const discardHandler = () => {
    setSelectedSite(0);
    setSelectedIncident(0);
    setTitle('');
    setDescription('');
    setSelectedAssociates([]);
    setFiles([]);
  };

  const submitHandler = async (e) => {
    e.preventDefault();
    if (!client || client == 0) {
      ToastUtil.error('Please select a Client.');
      return false;
    }

    if (!site || site == 0) {
      ToastUtil.error('Please select a Site.');
      return false;
    }

    if (!selectedIncident) {
      ToastUtil.error('Please select incident.');
      return false;
    }

    if (!title) {
      ToastUtil.error('Please enter title.');
      return false;
    }

    if (selectedAssociates.length === 0) {
      ToastUtil.error('Please select associates.');
      return false;
    }

    if (selectedTTGroups.length === 0) {
      ToastUtil.error(
        'Site has no TT Group. Please enquire with System Admin.'
      );
      return false;
    }

    if (
      await AlertService.confirm(
        '',
        'Are you sure you want to create this Trouble Ticket?'
      )
    ) {

      let formData = new FormData();

      formData.append('incident_id', selectedIncident.id);
      formData.append('title', title);
      formData.append('description', description);
      formData.append('associates', JSON.stringify(selectedAssociates));
      formData.append(
        'groups',
        JSON.stringify(selectedTTGroups.map((group) => group.id))
      );

      for (let file of files) {
        formData.append('files[]', file);
      }

      let api_path = `/site/${site}/ticket`;
      let response = await newFetch(POST, api_path, formData, 'multi');

      ToastUtil.success(response.message);
      response.success && history.push('/trouble-ticketing');
    }
  };

  return (
    <LayoutContext.Consumer>
      {({ activeSidebar }) => (
        <div style={{ paddingTop: '3rem', marginBottom: '6rem' }}>
          <div
            className="d-flex flex-column"
            style={{ paddingLeft: '3rem', paddingRight: '3rem' }}
          >
            <NavLink
              to="/trouble-ticketing"
              className="text-decoration-none"
              style={{ color: 'inherit' }}
            >
              <div>
                <i className="fas fa-chevron-left pe-2"></i> Trouble Ticketing
                (TT)
              </div>
            </NavLink>
            <div className="pt-4">
              <h3>Create New Ticket</h3>
            </div>
          </div>
          <div
            className="d-flex"
            style={{
              marginTop: '2rem',
              marginLeft: '3rem',
              marginRight: '3rem',
            }}
          >
            <div className="flex-grow-1">
              <div className="rounded shadow bg-white">
                <div className="p-4">
                  <div className="mb-2">
                      <strong>Client</strong>
                      <p
                        style={{
                          fontSize: 20,
                          color: '#595b5f',
                          fontWeight: 500,
                          paddingLeft: 8,
                        }}
                      >
                        {client_options &&
                          selectedClientID &&
                          client_options.find(
                            (clnt) => clnt.id === parseInt(selectedClientID)
                          )?.name}
                      </p>
                    </div>
                    <div className="mb-2">
                      <strong>Site</strong>
                      <p
                        style={{
                          fontSize: 20,
                          color: '#595b5f',
                          fontWeight: 500,
                          paddingLeft: 8,
                        }}
                      >
                        {site_options &&
                          site_options.find(
                            (siteData) => siteData.id === parseInt(site)
                          )?.name}
                      </p>
                    </div>
                  <div className="d-flex flex-column mt-4">
                    <strong>Select incident type</strong>
                    <select
                      className="form-select mt-2"
                      style={{ width: '300px' }}
                      value={(selectedIncident && selectedIncident.id) || ''}
                      onChange={(e) =>
                        setSelectedIncident(
                          incidents.find(
                            (incident) =>
                              incident.id === parseInt(e.target.value)
                          )
                        )
                      }
                    >
                      <option value="0">Select</option>
                      {incidents &&
                        incidents.length > 0 &&
                        incidents.map((incident) => (
                          <option key={incident.id} value={incident.id}>
                            {incident.name}
                          </option>
                        ))}
                    </select>
                  </div>

                  <div className="d-flex mt-4">
                    <div className="me-4">
                      <strong>SEV Level</strong>
                      <p className="mt-2">{SEV ? SEV.name : '-'}</p>
                    </div>
                    <div>
                      <strong>TT Groups</strong>
                      <p className="mt-2">
                        {selectedTTGroups && selectedTTGroups.length > 0
                          ? selectedTTGroups
                              .map((group) => group.name)
                              .join(', ')
                          : '-'}
                      </p>
                    </div>
                  </div>

                  <div className="d-flex flex-column">
                    <div className="mb-2 py-2">
                      <label htmlFor="ttTitle">
                        <strong>Title</strong>
                      </label>
                      <input
                        type="text"
                        className="form-control"
                        id="ttTitle"
                        placeholder="Ticket Title"
                        value={title}
                        onChange={(e) => setTitle(e.target.value)}
                      />
                    </div>
                    <div className="mb-2 py-2">
                      <label htmlFor="ttDescription">
                        <strong>Description</strong>
                      </label>
                      <textarea
                        className="form-control"
                        id="ttDescription"
                        rows="8"
                        style={{ resize: 'none' }}
                        placeholder="Ticket Description"
                        value={description}
                        onChange={(e) => setDescription(e.target.value)}
                      />
                    </div>
                    <div className="mb-2 py-2">
                      <label htmlFor="ttUpload">
                        <strong>Upload Files</strong>
                      </label>
                      <Upload
                        files={files}
                        setFiles={setFiles}
                        accept={
                          'application/pdf, image/jpg, image/jpeg, image/png'
                        }
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div
              className="d-flex flex-column"
              style={{ width: '250px', marginLeft: '2rem' }}
            >
              <strong>Tag Associates</strong>
              <Searchbar
                search={(e) => searchHandler(e)}
                placeholder="Search associates"
                width="100%"
              />

              <div className="d-flex justify-content-between mt-3">
                <p>Associates ({filteredAssociates.length})</p>
                {selectedAssociates.length === 0 ? (
                  <a
                    href="javascipt:void(0)"
                    onClick={(e) => selectAllHandler(e)}
                  >
                    Select All
                  </a>
                ) : selectedAssociates.length === filteredAssociates.length ? (
                  <a
                    href="javascipt:void(0)"
                    onClick={(e) => removeAllHandler(e)}
                  >
                    Remove All
                  </a>
                ) : (
                  <a
                    href="javascipt:void(0)"
                    onClick={(e) => removeAllHandler(e)}
                  >
                    Remove ({selectedAssociates.length})
                  </a>
                )}
              </div>
              {filteredAssociates.map((associate) => (
                <div
                  key={associate.id}
                  className="d-flex align-items-center my-1 py-1 rounded"
                  onClick={() => selectRemoveAssociateHandler(associate.id)}
                  style={
                    selectedAssociates.some((id) => id === associate.id)
                      ? { backgroundColor: '#f1f1f1' }
                      : {}
                  }
                >
                  <div className="mx-2">
                    <img
                      className="rounded-circle border me-3"
                      src={
                        associate.image
                          ? `${SERVER_URL}/${associate.image}`
                          : placeholderImage
                      }
                      alt="username-img"
                      style={{ height: '35px', width: '35px' }}
                    />
                  </div>
                  <div className="d-flex justify-content-between align-items-center w-100">
                    <div>
                      {`${associate.first_name} ${associate.last_name}`.length >
                      18
                        ? `${associate.first_name} ${associate.last_name}`.substr(
                            0,
                            18
                          ) + '...'
                        : `${associate.first_name} ${associate.last_name}`}
                    </div>
                    <div className="me-2">
                      {selectedAssociates.some((id) => id === associate.id) && (
                        <i className="fas fa-check text-muted" />
                      )}
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
          <form onSubmit={(e) => submitHandler(e)}>
            <div
              style={{
                position: 'fixed',
                bottom: 0,
                width: activeSidebar ? 'calc(100vw - 310px)' : '100vw',
                height: '4.5rem',
                paddingRight: '3rem',
              }}
              className="border-top bg-white d-flex align-items-center justify-content-end"
            >
              <button
                type="button"
                onClick={discardHandler}
                className="btn btn-outline-brand"
                style={{ width: '12rem' }}
              >
                Discard
              </button>
              <button
                type="submit"
                className="btn btn-brand ms-3"
                style={{ width: '12rem' }}
              >
                Save changes
              </button>
            </div>
          </form>
        </div>
      )}
    </LayoutContext.Consumer>
  );
};

export default withRouter(AddTT);
